/**
 * Настройки веба из окружения сборки (Vite): адрес API и версия.
 * По умолчанию API — тот же источник (в разработке Vite проксирует /api на бэкенд),
 * поэтому refresh-cookie и EventSource работают без CORS.
 */
function resolveApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_URL as string | undefined;
  if (configured && configured.trim() !== '') return configured.replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';
}

export const appConfig = {
  apiBaseUrl: resolveApiBaseUrl(),
  version: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0',
  /** Обновлять access-токен заранее, за столько мс до истечения. */
  refreshLeewayMs: 60 * 1000,
  /** Страница /_kit доступна без входа только в разработке. */
  kitPublic: import.meta.env.DEV,
} as const;
